import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Button, SimpleStepper } from "@powerdiary/components-library/lib";
import { createStepsWithLabels } from "../AppointmentBookingHeader.helpers";
import { ArrowLeft, ArrowRight, X } from "lucide-react";
import { STEP_CONFIRMATION } from "../../../bookingSlice.types";
import { useBookingNavigation } from "../../../hooks/useBookingNavigation";

import styles from "./HeaderDesktop.module.css";

interface IHeaderDesktopProps {
    handlePrevious: () => void;
    handleNext: () => void;
    handleCancel: () => void;
}

export default function HeaderDesktop({ handlePrevious, handleNext, handleCancel }: Readonly<IHeaderDesktopProps>) {
    const { effectiveStepOrder, effectiveCurrentStep, canGoPrevious, canGoNext } = useBookingNavigation();
    const theme = useTheme();

    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const currentStepIndex = effectiveStepOrder.indexOf(effectiveCurrentStep);
    const currentStep = currentStepIndex >= 0 ? currentStepIndex + 1 : 1;
    const totalSteps = effectiveStepOrder.length;
    const isConfirmationStep = effectiveCurrentStep === STEP_CONFIRMATION;

    return (
        <>
            <Box className={styles.desktopStepper} data-test-id="section_header_desktop">
                <SimpleStepper
                    sx={{ color: `${theme.palette.primary.main} !important` }}
                    activeStep={currentStep - 1}
                    steps={createStepsWithLabels(isTablet, totalSteps)}
                    orientation="horizontal"
                    dataTestIdSuffix="appointment_booking_desktop"
                />
            </Box>
            <Box className={styles.buttonGroup}>
                <Button
                    variant="outlined"
                    size="extraSmall"
                    startIcon={<ArrowLeft size={14} strokeWidth={2} aria-hidden />}
                    onClick={handlePrevious}
                    disabled={!canGoPrevious}
                    data-test-id="button_desktop_appointment_booking_back"
                >
                    BACK
                </Button>

                {isConfirmationStep ? (
                    <Button
                        variant="outlined"
                        size="extraSmall"
                        endIcon={<X size={14} strokeWidth={2} aria-hidden />}
                        onClick={handleCancel}
                        data-test-id="button_desktop_appointment_booking_cancel"
                    >
                        CANCEL
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        size="extraSmall"
                        endIcon={<ArrowRight size={14} strokeWidth={2} aria-hidden />}
                        onClick={handleNext}
                        disabled={!canGoNext}
                        data-test-id="button_desktop_appointment_booking_next"
                    >
                        NEXT
                    </Button>
                )}
            </Box>
        </>
    );
}
